import axios from 'axios'

const request = axios.create({
  baseURL: '/api',
  timeout: 10000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

request.interceptors.response.use(response => {
  const res = response.data
  if (res.code !== 0) {
    return Promise.reject(new Error(res.message || '请求失败'))
  }
  return res
})

export default request
